export const SITE_ROOT_URL =
  process.env.NEXT_PUBLIC_SITE_ROOT_URL || "https://lets-meal.com";
export const FAST_LANE_ROOT_URL =
  process.env.NEXT_PUBLIC_FAST_LANE_ROOT_URL || "https://fast-lane.app";
export const SITE_TITLE = "レツミル";
